<template>

  <div class="animated fadeIn">
    <b-row class="my-3">
      <b-col>
        <h4 class="text-center text-primary">
          <i class="fa fa-envelope text-primary mr-2"></i>
          Campañas
        </h4>
      </b-col>
    </b-row>

    <b-row md="12" class="pb-3">
      <b-col class="col-md-12">
        <b-row md="12">

          <b-card class="w-100">
            <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
              Estadísticas
              <div>
                <!-- <button

                  class="btn btn-primary btn-sm mr-2"
                >
                  <i class="fa fa-download"></i> CSV
                </button> -->
                <!-- <button

                  class="btn btn-primary btn-sm"
                >
                  <i class="fa fa-download"></i> Excel
                </button> -->
                <button
                  class="btn btn-primary btn-sm ml-2"
                  @click="exportStatistics()"
                >
                  <i class="fa fa-download"></i> PDF
                </button>
              </div>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-row>
                  <b-col cols="1">
                    <label>Fechas</label>
                  </b-col>
                  <b-col cols="5">
                    <v-date-picker
                      :input-props='{ class: "input", placeholder: "Fecha Inicio" }'
                      id="startDate"
                      v-model="statistics.startDate"
                      :max-date="new Date()"
                      class="date-picker-w-100 date-picker-custom-border">
                    </v-date-picker>
                  </b-col>
                  <b-col cols="5">
                    <v-date-picker
                      :input-props='{ class: "input", placeholder: "Fecha Fin" }'
                      id="endDate"
                      v-model="statistics.endDate"
                      :max-date="new Date()"
                      class="date-picker-w-100 date-picker-custom-border">
                    </v-date-picker>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="4">
                <b-row>
                  <b-col cols="2">
                    <label>Campañas</label>
                  </b-col>
                  <b-col cols="10">
                    <multiselect
                      v-model="selectedCampaign"
                      :options="campaigns"
                      :custom-label="opt => (opt && opt.nameCreatedAt) || ''"
                      :multiple="false"
                      :allowEmpty="true"
                      :loading="isLoadingCampaigns"
                      :internal-search="false"
                      placeholder="Buscar campaña..."
                      label="nameCreatedAt"
                      track-by="uuid"
                      :showNoResults="true"
                      class="multiselect-no-empty"
                      @search-change="onSearchCampaigns"
                      @input="updateCampaign">
                      <template slot="noOptions">Escribe para buscar campañas</template>
                    </multiselect>
                  </b-col>
                </b-row>
              </b-col>

              <b-col cols="2">
                <div class="d-flex flex-row-reverse">
                  <button
                    class="btn btn-pill btn-primary px-4"
                    @click="updateChart">
                    Filtrar
                  </button>
                </div>
              </b-col>
            </b-row>
            <div id="export">
              <b-row class="mt-2">
                <b-col cols="12">
                  <campaign-line-statistics ref="lineChart" id="lineChart"></campaign-line-statistics>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col cols="6" class="my-auto">
                  <b-row v-for="status in statusData('RED')" :key="status.name" class="ml-3">
                    <b-col cols="4">
                      <span :style="{ color: status.color }">&#9679;</span><span class="ml-2">{{ status.name }}</span>
                    </b-col>
                    <b-col cols="3">
                      <span>{{ status.percent }}%</span>
                    </b-col>
                    <b-col cols="2">
                      <span>{{ status.count }}</span>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="6">
                  <campaign-pie-statistics ref="pieChart" id="pieChart" class="pie-chart"></campaign-pie-statistics>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col cols="6" class="my-auto">
                  <b-row v-for="status in statusData('BLUE')" :key="status.name" class="ml-3">
                    <b-col cols="4">
                      <span :style="{ color: status.color }">&#9679;</span><span class="ml-2">{{ status.name }}</span>
                    </b-col>
                    <b-col cols="3">
                      <span>{{ status.percent }}%</span>
                    </b-col>
                    <b-col cols="2">
                      <span>{{ status.count }}</span>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="6">
                  <campaign-pie-statistics ref="pieBlueChart" id="pieBlueChart"></campaign-pie-statistics>
                </b-col>
              </b-row>
            </div>

            <b-row class="m-0 p-0 justify-content-between align-items-center mt-5">
              Emails Enviados
              <div>
                <button
                  :disabled="count < 1"
                  class="btn btn-primary btn-sm mr-2"
                  @click="exportSearch('csv')">
                  <i class="fa fa-download"></i> CSV
                </button>
                <button
                  :disabled="count < 1"
                  class="btn btn-primary btn-sm"
                  @click="exportSearch('xlsx')">
                  <i class="fa fa-download"></i> Excel
                </button>
                <button
                  :disabled="count < 1"
                  class="btn btn-primary btn-sm ml-2"
                  @click="exportSearch('pdf')">
                  <i class="fa fa-download"></i> PDF
                </button>
              </div>
            </b-row>
            <b-row md="12" class="mb-3 mt-4 border-top-primary px-2">
              <b-col class="col-md-5">
                <b-form-group label="Buscar" :label-cols="3" :horizontal="true" class="w-100 mb-0">
                  <b-form-input
                    v-model="statisticsEmail.search"
                    id="string"
                    name="string"
                    type="text"
                    placeholder="Busqueda general"
                    class="w-100"
                    v-validate="'min:3'"
                    aria-describedby="check_string">
                  </b-form-input>
                  <div class="text-danger text-right" id="check_string">
                    <small>{{ errors.first('string') }}</small>
                  </div>
                </b-form-group>
              </b-col>

              <b-col cols="4">
                <b-row>
                  <b-form-group label="Estado" :label-cols="3" :horizontal="true" class="w-100 mb-0">
                    <multiselect
                      name="status"
                      v-model="selectedEmailCampaign"
                      :options="status.map(type => type.value)"
                      :custom-label="opt => status.find(x => x.value == opt).label"
                      :multiple="true"
                      :allowEmpty="true"
                      placeholder="Estado"
                      selectLabel="+"
                      deselectLabel="-"
                      @input="updateEmailCampaign">
                    </multiselect>
                  </b-form-group>
                </b-row>
              </b-col>

              <b-col class="col-md-3">
                <button
                  class="btn btn-pill btn-primary ml-4 float-right"
                  @click="search">
                  Buscar Email Enviado
                </button>
              </b-col>
            </b-row>
            <v-server-table
              :columns="columns"
              :options="options"
              :theme="theme"
              class="dataTable mt-4"
              ref="dataCampaignTable"
              md="12"
              lg="12"
              sm="12"
              @sorted="tableSorted">
              <template slot="beforeBody">
                <tr v-if="loading">
                  <td class="text-center loading" colspan="7">
                    <spinner size="medium" line-fg-color="#025542" line-bg-color="#c8ced3"></spinner>
                  </td>
                </tr>
              </template>
            </v-server-table>
          </b-card>
        </b-row>
      </b-col>
    </b-row>


  </div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import Vue from 'vue';
import {ClientTable, Event, ServerTable} from 'vue-tables-2';
import form from '@/helpers/form';
import LastActivity from '@/components/activity/LastActivity';
import CampaignPieStatistics from "@/components/statistics/CampaignPieStatistics.vue";
import CampaignLineStatistics from "@/components/statistics/CampaignLineStatistics.vue";
import 'v-calendar/lib/v-calendar.min.css';
import {DatePicker} from "v-calendar";
import {getCampaigns, getSearchCampaigns} from "@/api/campaign-api";
import moment from 'moment';
import Exporter from "vue-chartjs-exporter";
import {downloadJsonAsCsv, downloadJsonAsXlsx} from '@/helpers/js-xlsx';
import {downloadJsonAsPdf} from '@/helpers/js-pdf';
import jsPDF from "jspdf";
import Spinner from 'vue-simple-spinner';

Vue.use(ServerTable);

export default {
  name: 'statisticsCampaign',
  components: {
    'v-date-picker': DatePicker,
    CampaignPieStatistics,
    CampaignLineStatistics,
    ClientTable,
    Event,
    Multiselect,
    LastActivity,
    Spinner
  },
  mounted() {
    this.$eventHub.$emit('captureMenu', this.topmenu);
    
    if (this.$route.query.campaign) {
      this.statistics.campaign = this.$route.query.campaign;
      if (this.$route.query.startDate) {
        this.statistics.startDate = new Date(this.$route.query.startDate);
      }
      if (this.$route.query.endDate) {
        this.statistics.endDate = new Date(this.$route.query.endDate);
      }
      
      this.loadCampaignData(this.statistics.campaign).then(() => {
        this.updateChart();
      });
    }
    
    Event.$on('vue-tables.loading', () => {
      this.$_loadingMixin_showLoading();
      this.count = 0;
      this.loading = true;
      const noResults = document.querySelector('.VueTables__no-results');
      if (noResults) noResults.style.display = 'none';
    });
    Event.$on('vue-tables.loaded', (data) => {
      if (data && data.data && data.data.total) {
        this.count = data.data.total;
      }
      this.$_loadingMixin_hideLoading();
      this.loading = false;
      const noResults = document.querySelector('.VueTables__no-results');
      if (noResults) noResults.style.display = 'table-row';
    });
  },
  data() {
    return {
      topmenu: [
        {
          name: 'Campañas',
          path: '/communications/campaign/list',
          brand: 'fa fa-envelope'
        },
      ],
      responseData: [],
      selectedCampaign: null,
      selectedEmailCampaign: null,
      campaigns: [],
      isLoadingCampaigns: false,
      searchDebounceTimer: null,
     status: [
        {
            value: "SENT",
            label: "Enviado"
        },
        {
            value: "QUEUED",
            label: "En Cola"
        },
        {
            value: "SCHEDULED",
            label: "Programado"
        },
        {
            value: "REJECTED",
            label: "Rechazado"
        },
        {
            value: "INVALID",
            label: "Inválido"
        }      
      ],
      statistics: {
        campaign: null,
        startDate: null,
        endDate: null,
      },
      statisticsEmail: {
        search: '',
        status: null,
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',

      entity: {
        string: null,
        page: 1,
        itemsPerPage: 10,
      },
      orderBy: {
        column: null,
        ascending: null
      },
      count: 0,
      loading: true,
      options: {
        headings: {
          // uuid: {
          //   text: '',
          //   id: 'fit'
          // },
          campaignName: 'Campaña',
          email: 'Email',
          status: 'Estado',
          sentAt: 'Fecha',
          clicksCount: 'Clicks',
          opensCount: 'Opens',
        },
        requestFunction: data => {
          if (this.$store.getters.getFilters[0] !== null) {
            this.entity.string = this.$store.getters.getFilters[0];
          }
          this.entity.page = data.page;
          this.entity.itemsPerPage = data.limit;
          return axios({
            url: 'campaigns/emails/search',
            method: 'get',
            params: this.searchFilters
          }).catch(function (e) {
            self.dispatch('error', e);
          }.bind(this));
        },
        responseAdapter: ({data}) => {
          const statusMap = {
            SENT:      'Enviado',
            QUEUED:    'En Cola',
            SCHEDULED: 'Programado',
            REJECTED:  'Rechazado',
            INVALID:   'Inválido',
          };
          data.result.forEach(row => {
            row.sentAt      = row.sentAt ? new Date(row.sentAt).toISOString().split('T')[0] : '';
            row.opensCount  = row.opensCount  || 0;
            row.clicksCount = row.clicksCount || 0;
            row.status      = statusMap[row.status] || row.status;
          });
          return {
            data: data.result,
            count: data.total
          }
        },
        columnsClasses: {uuid: "fit"},
        sortable: ['name'],
        filterable: false,
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        perPageValues: [10, 25, 50, 100, 500, 1000, 10000, 100000],
        texts: form.tableLabels(),
        pagination: {
          chunk: 10,
          edge: true,
          nav: 'scroll'
        }
      },
      columns: [
        // 'uuid',
        'campaignName',
        'email',
        'status',
        'sentAt',
        'clicksCount',
        'opensCount'
      ],
    }
  },
  computed: {

    searchFilters() {
      return {
        string: this.entity.string,
        page: this.entity.page,
        itemsPerPage: this.entity.itemsPerPage,
        orderColumn: this.orderBy.column,
        orderAscending: this.orderBy.ascending ? 1 : 0,
        search: this.statisticsEmail.search,
        status: this.statisticsEmail.status,
        startDate: this.statistics.startDate,
        endDate: this.statistics.endDate,
        campaign: this.statistics.campaign

      }
    },
  },
  methods: {

    onSearchCampaigns(query) {
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }
      if (!query) {
        this.campaigns = [];
        this.isLoadingCampaigns = false;
        return;
      }
      const isNumeric = /^\d+$/.test(query);
      const minLength = isNumeric ? 1 : 2;
      if (query.length < minLength) {
        this.campaigns = [];
        this.isLoadingCampaigns = false;
        return;
      }
      this.isLoadingCampaigns = true;
      this.searchDebounceTimer = setTimeout(() => {
        this.fetchCampaignsByName(query);
      }, 350);
    },

    async fetchCampaignsByName(query) {
      try {
        const response = await getCampaigns({ 
          string: query, 
          page: 1, 
          itemsPerPage: 20 
        });
        if (response && response.campaigns) {
          this.campaigns = response.campaigns.map(c => ({
            ...c,
            nameCreatedAt:
              (c.createdAt ? moment(c.createdAt).format('DD/MM/YYYY') : '') +
              ' - ' + c.name,
          }));
        } else {
          this.campaigns = [];
        }
      } catch (e) {
        console.error('Error buscando campañas:', e);
        this.campaigns = [];
      } finally {
        this.isLoadingCampaigns = false;
      }
    },

    updateCampaign(value) {
      this.statistics.campaign = value ? value.uuid : null;
    },

    async loadCampaignData(campaignUuid) {
      try {
        this.isLoadingCampaigns = true;
        const response = await getCampaigns({ 
          page: 1, 
          itemsPerPage: 100,
        });
        if (response && response.campaigns) {
          const campaign = response.campaigns.find(c => c.uuid === campaignUuid);
          if (campaign) {
            this.selectedCampaign = {
              ...campaign,
              nameCreatedAt:
                (campaign.createdAt ? moment(campaign.createdAt).format('DD/MM/YYYY') : '') +
                ' - ' + campaign.name,
            };
          }
        }
      } catch (e) {
        console.error('Error cargando campaña:', e);
      } finally {
        this.isLoadingCampaigns = false;
      }
    },

    statusData(group) {
      const statusTranslations = {
        SENT: 'Enviado',
        QUEUED: 'En Cola',
        SCHEDULED: 'Programado',
        REJECTED: 'Rechazado',
        INVALID: 'Inválido',
        UNSUBSCRIBED: 'Dado De Baja',
        OPENS: 'Opens',
        CLICKS: 'Clicks'
      };

      const knownStatusesRed = ['SENT', 'QUEUED', 'SCHEDULED', 'REJECTED', 'INVALID'];
      const knownStatusesBlue = ['UNSUBSCRIBED', 'OPENS', 'CLICKS'];
      const statusCountsRed  = Object.fromEntries(knownStatusesRed.map(k  => [k, 0]));
      const statusCountsBlue = Object.fromEntries(knownStatusesBlue.map(k => [k, 0]));


      this.responseData.forEach(entry => {
        const n = parseInt(entry.count) || 0;
        if (knownStatusesRed.includes(entry.status))  statusCountsRed[entry.status]  += n;
        if (knownStatusesBlue.includes(entry.status)) statusCountsBlue[entry.status] += n;
      });

      const total = knownStatusesRed.reduce((acc, k) => acc + statusCountsRed[k], 0);

      const redData = knownStatusesRed.map(k => ({
        name: statusTranslations[k],
        count: statusCountsRed[k],
        percent: total > 0 ? ((statusCountsRed[k] * 100) / total).toFixed(2) : '0.00',
        color: this.getColor(k),
      }));
      const blueData = knownStatusesBlue.map(k => ({
        name:    statusTranslations[k],
        count:   statusCountsBlue[k],
        percent: ((statusCountsBlue[k] * 100) / (statusCountsRed['SENT'] || 1)).toFixed(2),
        color:   this.getColor(k),
      }));

      if (group === 'RED')  return redData;
      if (group === 'BLUE') return blueData;
      return redData.concat(blueData);
    },

    getColor(status) {
      const colors = {
        SENT:         '#68BD7B',
        QUEUED:       '#3b91f1',
        SCHEDULED:    '#FFCE56',
        REJECTED:     '#f87979',
        INVALID:      '#7a7979',
        UNSUBSCRIBED: '#ff0000',
        OPENS:        '#00a9ff',
        CLICKS:       '#ee02ff',
      };
      return colors[status] || '#000000';
    },

    async updateChart() {
      try {
        if (!this.statistics.campaign) {
          alert('Por favor selecciona una campaña');
          return;
        }

        let startDate = this.statistics.startDate;
        let endDate = this.statistics.endDate;

        if (!startDate || !endDate) {
          const campaignCreatedAt = this.selectedCampaign && this.selectedCampaign.createdAt;
          if (campaignCreatedAt) {
            if (!startDate) {
              startDate = moment(campaignCreatedAt).subtract(7, 'days').toDate();
            }
            if (!endDate) {
              endDate = moment().toDate();
            }
          } else {
            alert('No se pudo obtener la fecha de creación de la campaña');
            return;
          }
        }

        this.statistics.startDate = startDate;
        this.statistics.endDate = endDate;

        this.$refs.dataCampaignTable.refresh();
        const responseData = await getSearchCampaigns({
          startDate: moment(startDate).format('YYYY-MM-DD'),
          endDate:   moment(endDate).format('YYYY-MM-DD'),
          campaign:  this.statistics.campaign,
        });
        this.responseData = responseData;
        this.updateChartData(responseData, this.statistics);
      } catch (error) {
        console.error('Error actualizando gráfico:', error);
      }
    },

    updateChartData(responseData, statistics) {
      this.$refs.lineChart.updateChartWithData(responseData, statistics);
      const knownStatusesRed  = ['SENT', 'QUEUED', 'SCHEDULED', 'REJECTED', 'INVALID'];
      const knownStatusesBlue = ['UNSUBSCRIBED', 'OPENS', 'CLICKS'];
      this.$refs.pieChart.updateChartWithData(
        responseData.filter(i => knownStatusesRed.includes(i.status)), statistics
      );
      this.$refs.pieBlueChart.updateChartWithData(
        responseData.filter(i => knownStatusesBlue.includes(i.status)), statistics
      );
    },

    search() {
      this.$refs.dataCampaignTable.refresh();
    },

    tableSorted(data) {
      this.orderBy.column    = data.column;
      this.orderBy.ascending = data.ascending;
    },

    updateEmailCampaign(value) {
      this.statisticsEmail.status = value && value.length ? value.join(',') : null;
    },

    normalizeFieldList(field) {
      return {
        'Campaña': field.campaignName ? field.campaignName.toString() : '',
        'Email': field.email ? field.email.toString() : '',
        'Estado': field.status ? field.status.toString() : '',
        'Fecha': field.sentAt ? field.sentAt.toString() : '',
        'Clicks': field.clicksCount || 0,
        'Opens': field.opensCount || 0,
      };
    },

    async exportSearch(format) {
      if (this.count > 0) {
        this.$_loadingMixin_showLoading();
        try {
          const response = await axios({
            method: 'get',
            url: 'campaigns/emails/search',
            params: {
              search:    this.statisticsEmail.search,
              status:    this.statisticsEmail.status,
              startDate: this.statistics.startDate,
              endDate:   this.statistics.endDate,
              campaign:  this.statistics.campaign,
            },
          });
          const rows = response.data.result.map(f => this.normalizeFieldList(f));
          if (format === 'csv')  downloadJsonAsCsv(rows);
          if (format === 'xlsx') downloadJsonAsXlsx(rows);
          if (format === 'pdf')  downloadJsonAsPdf(rows);
        } catch (e) {
          console.error('Error exportando:', e);
        } finally {
          this.$_loadingMixin_hideLoading();
        }
      }
    },

    async exportStatistics() {
      let campaignDate = moment().format('DD/MM/YYYY HH:mm');
      let campaignName = 'Todas Las Campañas';

      if (this.selectedCampaign && this.selectedCampaign.name) {
        campaignDate = moment(this.selectedCampaign.createdAt).format('DD/MM/YYYY HH:mm');
        campaignName = this.selectedCampaign.name;
      }

      const divElement = document.createElement('div');
      divElement.innerHTML = `
        <div class="mb-5">
          <div class="text-center">
            <div class="row">
              <div class="col">
                  <img class="img-fluid mt-5 col-2" src="img/logo.png" fluid alt="Logo de ATA Cloud"></img>
                <section class="bg-primary text-white pt-3 pb-2 mt-5 mb-3">
                  <p>Reporte de Campaña</p>
                  <h1>${campaignName}</h1>
                  <p>Estadísticas del ${campaignDate}</p>
                </section>
              </div>
            </div>
          </div>
        </div>`;
      let cardBodyContent = document.getElementById('export');
      cardBodyContent.insertBefore(divElement, cardBodyContent.firstChild);
      const exp = new Exporter([cardBodyContent]);
      exp.doc = new jsPDF('p', 'px', 'letter');
      exp.export_pdf().then(pdf => pdf.save('charts.pdf'));
      cardBodyContent.removeChild(divElement);
    },
  },
};
</script>

<style>
.date-picker-custom-border input[type="text"] {
  color: #5c6873 !important;
  border: 1px solid #e4e7ea !important;
}

.no-bullets {
  list-style-type: none;
}
canvas#pie-chart{
  width:50%;
  height:50%;
}
</style>
